import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function n(n) {
  return void 0 !== n.xmin && void 0 !== n.ymin && void 0 !== n.xmax && void 0 !== n.ymax;
}

function t(n) {
  return void 0 !== n.points;
}

function e(n) {
  return void 0 !== n.x && void 0 !== n.y;
}

function o(n) {
  return void 0 !== n.paths;
}

function i(n) {
  return void 0 !== n.rings;
}

function l(n) {
  return function (t, e) {
    return null == t ? e : null == e ? t : n(t, e);
  };
}

var r = l(Math.min),
    u = l(Math.max);

function c(l, r) {
  return o(r) ? h(l, r.paths, !1, !1) : i(r) ? h(l, r.rings, !1, !1) : t(r) ? s(l, r.points, !1, !1, !1, !1) : n(r) ? g(l, r) : (e(r) && (l[0] = r.x, l[1] = r.y, l[2] = r.x, l[3] = r.y), l);
}

function f(l, r) {
  return o(r) ? h(l, r.paths, !0, !1) : i(r) ? h(l, r.rings, !0, !1) : t(r) ? s(l, r.points, !0, !1, !0, !1) : n(r) ? g(l, r, !0, !1, !0, !1) : (e(r) && (l[0] = r.x, l[1] = r.y, l[2] = r.z, l[3] = r.x, l[4] = r.y, l[5] = r.z), l);
}

function h(n, t, e, o) {
  var i = e ? 3 : 2;
  if (!t.length || !t[0].length) return null;

  var l,
      c,
      f,
      h,
      _t$0$ = _slicedToArray(t[0][0], 2),
      g = _t$0$[0],
      s = _t$0$[1],
      _t$0$2 = _slicedToArray(t[0][0], 2),
      x = _t$0$2[0],
      m = _t$0$2[1];

  for (var a = 0; a < t.length; a++) {
    var _n = t[a];

    for (var _t = 0; _t < _n.length; _t++) {
      var _a = _n[_t],
          _a2 = _slicedToArray(_a, 2),
          d = _a2[0],
          v = _a2[1];

      if (g = r(g, d), s = r(s, v), x = u(x, d), m = u(m, v), e && _a.length > 2) {
        var _n2 = _a[2];
        l = r(l, _n2), c = u(c, _n2);
      }

      if (o && _a.length > i) {
        var _n3 = _a[i];
        f = r(l, _n3), h = u(c, _n3);
      }
    }
  }

  return e ? o ? (n[0] = g, n[1] = s, n[2] = l, n[3] = f, n[4] = x, n[5] = m, n[6] = c, n[7] = h, n.length = 8, n) : (n[0] = g, n[1] = s, n[2] = l, n[3] = x, n[4] = m, n[5] = c, n.length = 6, n) : o ? (n[0] = g, n[1] = s, n[2] = f, n[3] = x, n[4] = m, n[5] = h, n.length = 6, n) : (n[0] = g, n[1] = s, n[2] = x, n[3] = m, n.length = 4, n);
}

function g(n, t, e, o, i, l) {
  var r = t.xmin,
      u = t.xmax,
      c = t.ymin,
      f = t.ymax;
  var h = t.zmin,
      g = t.zmax,
      s = t.mmin,
      x = t.mmax;
  return i ? (h = h || 0, g = g || 0, l ? (s = s || 0, x = x || 0, n[0] = r, n[1] = c, n[2] = h, n[3] = s, n[4] = u, n[5] = f, n[6] = g, n[7] = x, n) : (n[0] = r, n[1] = c, n[2] = h, n[3] = u, n[4] = f, n[5] = g, n)) : l ? (s = s || 0, x = x || 0, n[0] = r, n[1] = c, n[2] = s, n[3] = u, n[4] = f, n[5] = x, n) : (n[0] = r, n[1] = c, n[2] = u, n[3] = f, n);
}

function s(n, t, e, o, i, l) {
  var c = e ? 3 : 2,
      f = o && l,
      h = e && i;
  if (!t.length || !t[0].length) return null;

  var g,
      s,
      x,
      m,
      _t$ = _slicedToArray(t[0], 2),
      a = _t$[0],
      d = _t$[1],
      _t$2 = _slicedToArray(t[0], 2),
      v = _t$2[0],
      y = _t$2[1];

  for (var p = 0; p < t.length; p++) {
    var _n4 = t[p],
        _n5 = _slicedToArray(_n4, 2),
        _e = _n5[0],
        _o = _n5[1];

    if (a = r(a, _e), d = r(d, _o), v = u(v, _e), y = u(y, _o), h && _n4.length > 2) {
      var _t2 = _n4[2];
      g = r(g, _t2), s = u(s, _t2);
    }

    if (f && _n4.length > c) {
      var _t3 = _n4[c];
      x = r(g, _t3), m = u(s, _t3);
    }
  }

  return i ? (g = g || 0, s = s || 0, l ? (x = x || 0, m = m || 0, n[0] = a, n[1] = d, n[2] = g, n[3] = x, n[4] = v, n[5] = y, n[6] = s, n[7] = m, n) : (n[0] = a, n[1] = d, n[2] = g, n[3] = v, n[4] = y, n[5] = s, n)) : l ? (x = x || 0, m = m || 0, n[0] = a, n[1] = d, n[2] = x, n[3] = v, n[4] = y, n[5] = m, n) : (n[0] = a, n[1] = d, n[2] = v, n[3] = y, n);
}

function x(n) {
  if (!n.length || !n[0].length) return null;

  var _n$ = _slicedToArray(n[0], 1),
      t = _n$[0],
      _n$2 = _slicedToArray(n[0], 1),
      e = _n$2[0];

  for (var _o2 = 0; _o2 < n.length; _o2++) {
    var _i = n[_o2],
        _i2 = _slicedToArray(_i, 1),
        _l = _i2[0];

    t = r(t, _l), e = u(e, _l);
  }

  return e - t;
}

function m(n) {
  if (!n.length || !n[0].length) return null;

  var _n$3 = _slicedToArray(n[0], 1),
      t = _n$3[0],
      _n$4 = _slicedToArray(n[0], 1),
      e = _n$4[0];

  for (var _o3 = 0; _o3 < n.length; _o3++) {
    var _i3 = n[_o3],
        _i4 = _slicedToArray(_i3, 1),
        _l2 = _i4[0];

    t = r(t, _l2), e = u(e, _l2);
  }

  return t + .5 * (e - t);
}

export { c as getBoundsXY, f as getBoundsXYZ, g as getExtentBounds, s as getPointsBounds, m as getPointsBoundsCenterX, x as getPointsBoundsWidth, h as getRingsOrPathsBounds };